<template>
  <div class="telaCadastro" style="min-height: 100vh">
    <header-novo-usuario />
    <b-alert :show="pendenteValid == true" variant="warning" class="mt-4">
      O seu cadastro está em fase de validação, em breve entraremos em contato
      via e-mail.
    </b-alert>
    <validation-observer ref="validationobserver">
      <b-form @submit.prevent="salvarNovoUsuario">
        <b-card header-tag="header" no-body class="m-3">
          <template #header>
            <header-sagres titulo="Completar dados:" breakpoint="xl" />
            <b-button
              v-if="!pendenteValid"
              class="float-right m-1"
              size="sm"
              type="submit"
            >
              <font-awesome-icon icon="save" />Salvar
            </b-button>
          </template>
          <b-overlay :show="overlayCard">
            <b-card-body>
              <b-container fluid class="mt-3">
                <p class="text-left"><strong>Informações pessoais</strong></p>
                <b-row class="w-100">
                  <b-col cols="12" md="6" xl="4">
                    <default-form-validation-provider
                      label="Nome"
                      v-slot="defaultState"
                      rules="required"
                    >
                      <b-form-input
                        :disabled="pendenteValid"
                        id="input-nome"
                        :state="defaultState.state"
                        placeholder="Digite seu nome"
                        v-model="novoUsuario.NOME"
                        maxlength="80"
                      />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" md="6" xl="4">
                    <default-form-validation-provider
                      label="CPF"
                      v-slot="defaultState"
                    >
                    <b-form-input
                      :disabled="pendenteValid"
                      :value="cpfFormatted"
                      @input="onCpfInput"
                      @keydown="onCpfKeydown"
                      :state="defaultState.state"
                      placeholder="Digite seu CPF"
                      v-bind="cpfMaskedInputProps"
                    />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" md="6" xl="4">
                    <default-form-validation-provider
                      label="Email"
                      v-slot="defaultState"
                    >
                      <b-form-input
                        :disabled="pendenteValid"
                        v-model="novoUsuario.EMAIL"
                        type="email"
                        placeholder="Digite seu Email"
                        :state="defaultState.state"
                      />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" md="6" xl="4">
                    <default-form-validation-provider 
                    label="Telefone" 
                    v-slot="defaultState"
                    >
                    <b-form-input
                    :disabled="pendenteValid"
                    :value="telefoneFormatted"
                    @input="onTelefoneInput"
                    @keydown="onTelefoneKeydown"
                    placeholder="Digite seu Telefone"
                    :state="defaultState.state"
                    v-bind="telefoneMaskedInputProps"
                    />
                </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" md="6" xl="4">
                    <default-form-validation-provider
                      label="Código OAB"
                      v-slot="defaultState"
                      rules=""
                    >
                      <b-form-input
                        :disabled="pendenteValid"
                        v-model="novoUsuario.OAB"
                        :state="defaultState.state"
                        placeholder="Digite seu código OAB"
                        maxlength="8"
                      />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" md="6" xl="4">
                    <default-form-validation-provider
                      label="Autoriza comunicação por email, SMS, ZAP ou afins"
                      v-slot="defaultState"
                    >
                      <b-form-radio-group
                        :disabled="pendenteValid"
                        v-model="novoUsuario.FL_COMUNICA_TELEFONE"
                        :options="comunicaTelefoneOptions"
                        :state="defaultState.state"
                        size="sm"
                      >
                      </b-form-radio-group>
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" md="6" xl="4" v-if="paginaCadastro">
                    <default-form-validation-provider
                      label="Senha (para acesso sem token)"
                      :rules="paginaCadastro ? 'required' : ''"
                      v-slot="defaultState"
                    >
                      <b-form-input
                        :disabled="pendenteValid"
                        v-model="novoUsuario.SENHA"
                        :state="defaultState.state"
                        placeholder="Digite uma senha (para acesso sem token)"
                        type="password"
                      />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" md="6" xl="4" v-if="paginaCadastro">
                    <default-form-validation-provider
                      label="Repita a senha"
                      :rules="paginaCadastro ? 'required' : ''"
                      v-slot="defaultState"
                    >
                      <b-form-input
                        :disabled="pendenteValid"
                        v-model="confirmaSenha"
                        :state="defaultState.state"
                        placeholder="Digite novamente a senha"
                        type="password"
                      />
                    </default-form-validation-provider>
                  </b-col>
                </b-row>
                <p class="text-left">
                  <strong>Endereço</strong>
                </p>
                <b-row>
                  <b-col cols="12" md="6" xl="4">
                    <default-form-validation-provider
                      label="Logradouro"
                      v-slot="defaultState"
                    >
                      <b-form-input
                        :disabled="pendenteValid"
                        id="input-logradouro"
                        v-model="novoUsuario.LOGRADOURO"
                        placeholder="Digite seu Logradouro"
                        :state="defaultState.state"
                      />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" md="6" xl="4">
                    <default-form-validation-provider
                      label="Número"
                      v-slot="defaultState"
                    >
                      <b-form-input
                        :disabled="pendenteValid"
                        id="input-nro"
                        placeholder="Digite o número do seu endereço"
                        v-model="novoUsuario.NUMERO"
                        type="number"
                        :state="defaultState.state"
                      />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" md="6" xl="4">
                    <default-form-validation-provider
                      label="Complemento"
                      v-slot="defaultState"
                      rules=""
                    >
                      <b-form-input
                        :disabled="pendenteValid"
                        id="input-complemento"
                        placeholder="Digite seu complemento"
                        v-model="novoUsuario.COMPLEMENTO"
                        :state="defaultState.state"
                      />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" md="6" xl="4">
                    <default-form-validation-provider
                      label="Bairro"
                      v-slot="defaultState"
                    >
                      <b-form-input
                        :disabled="pendenteValid"
                        id="input-bairro"
                        placeholder="Digite seu bairro"
                        v-model="novoUsuario.BAIRRO"
                        :state="defaultState.state"
                      />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" md="6" xl="4">
                    <default-form-validation-provider
                      label="CEP"
                      v-slot="defaultState"
                    >
                    <b-form-input
                      :disabled="pendenteValid"
                      id="input-cep"
                      :value="cepFormatted"
                      @input="onCepInput"
                      @keydown="onCepKeydown"
                      placeholder="Digite seu CEP"
                      :state="defaultState.state"
                      v-bind="cepMaskedInputProps"
                    />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" md="6" xl="4">
                    <b-overlay :show="loadingMunicipios">
                      <default-form-validation-provider
                        label="Unidade Federativa"
                        v-slot="defaultState"
                      >
                        <b-form-select
                          :disabled="pendenteValid"
                          id="select-estado"
                          :options="listaUFs"
                          v-model="ufEscolhido"
                          :state="defaultState.state"
                          @change="listarMunicipios"
                        />
                      </default-form-validation-provider>
                    </b-overlay>
                  </b-col>
                  <b-col cols="12" md="6" xl="4">
                    <b-overlay :show="loadingMunicipios">
                      <default-form-validation-provider
                        label="Município"
                        v-slot="defaultState"
                      >
                        <b-form-select
                          id="select-municipio"
                          v-model="novoUsuario.ID_MUNICIPIO"
                          :options="listaMunicipios"
                          :state="defaultState.state"
                          :disabled="!ufEscolhido || pendenteValid"
                        />
                      </default-form-validation-provider>
                    </b-overlay>
                  </b-col>
                </b-row>
                <p class="text-left"><strong>Documentos</strong></p>
                <b-row>
                  <b-col cols="12" md="6" xl="4">
                    <default-form-validation-provider
                      v-if="novoUsuario.getTipoArquivo('cpf') === 'salvo'"
                      label="Documento com foto e CPF (ou OAB)"
                    >
                      <span v-if="novoUsuario && novoUsuario.doc_foto">
                        <b-button
                          v-if="pendenteValid"
                          variant="outline"
                          @click="
                            realizarDownloadAnexo(
                              novoUsuario.doc_foto.ID_ANEXO,
                              novoUsuario.doc_foto.NOME_ANEXO
                            )
                          "
                          ><font-awesome-icon icon="fa-solid fa-download"
                        /></b-button>
                        Nome: {{ novoUsuario.doc_foto.NOME_ANEXO }}
                      </span>

                      <div
                        v-if="!pendenteValid"
                        class="d-flex justify-content-center"
                      >
                        <b-link
                          class="text-dark"
                          @click="removerArquivo('cpf')"
                        />
                        <b-link
                          class="text-dark"
                          @click="removerArquivo('cpf')"
                        >
                          <font-awesome-icon icon="times" />
                          <div style="font-size: 12px">Remover</div>
                        </b-link>
                      </div>
                    </default-form-validation-provider>
                    <default-form-validation-provider
                      v-else
                      label="Documento com foto e CPF (ou OAB)"
                      v-slot="defaultState"
                    >
                      <b-form-file
                        :disabled="pendenteValid"
                        v-model="novoUsuario.doc_foto"
                        placeholder="Nenhum arquivo selecionado"
                        accept="application/pdf"
                        :state="defaultState.state"
                      />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" md="6" xl="4">
                    <default-form-validation-provider
                      v-if="novoUsuario.getTipoArquivo('cpf_verso') === 'salvo'"
                      label="Verso do documento (opcional)"
                      rules=""
                    >
                      <span v-if="novoUsuario && novoUsuario.doc_foto_verso">
                        <b-button
                          v-if="pendenteValid"
                          variant="outline"
                          @click="
                            realizarDownloadAnexo(
                              novoUsuario.doc_foto_verso.ID_ANEXO,
                              novoUsuario.doc_foto_verso.NOME_ANEXO
                            )
                          "
                          ><font-awesome-icon icon="fa-solid fa-download"
                        /></b-button>
                        Nome: {{ novoUsuario.doc_foto_verso.NOME_ANEXO }}
                      </span>
                      <div
                        v-if="!pendenteValid"
                        class="d-flex justify-content-center"
                      >
                        <b-link
                          class="text-dark"
                          @click="removerArquivo('cpf_verso')"
                        />
                        <b-link
                          class="text-dark"
                          @click="removerArquivo('cpf_verso')"
                        >
                          <font-awesome-icon icon="times" />
                          <div style="font-size: 12px">Remover</div>
                        </b-link>
                      </div>
                    </default-form-validation-provider>
                    <default-form-validation-provider
                      v-else
                      label="Verso do documento (opcional)"
                      v-slot="defaultState"
                      rules=""
                    >
                      <b-form-file
                        :disabled="pendenteValid"
                        v-model="novoUsuario.doc_foto_verso"
                        placeholder="Nenhum arquivo selecionado"
                        accept="application/pdf"
                        :state="defaultState.state"
                      />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" md="6" xl="4">
                    <default-form-validation-provider
                      v-if="
                        novoUsuario.getTipoArquivo('residencia') === 'salvo'
                      "
                      label="Comprovante de residência"
                    >
                      <span v-if="novoUsuario && novoUsuario.comp_residencia">
                        <b-button
                          v-if="pendenteValid"
                          variant="outline"
                          @click="
                            realizarDownloadAnexo(
                              novoUsuario.comp_residencia.ID_ANEXO,
                              novoUsuario.comp_residencia.NOME_ANEXO
                            )
                          "
                          ><font-awesome-icon icon="fa-solid fa-download"
                        /></b-button>
                        Nome: {{ novoUsuario.comp_residencia.NOME_ANEXO }}
                      </span>
                      <div
                        v-if="!pendenteValid"
                        class="d-flex justify-content-center"
                      >
                        <b-link
                          class="text-dark"
                          @click="removerArquivo('residencia')"
                        />
                        <b-link
                          class="text-dark"
                          @click="removerArquivo('residencia')"
                        >
                          <font-awesome-icon icon="times" />
                          <div style="font-size: 12px">Remover</div>
                        </b-link>
                      </div>
                    </default-form-validation-provider>
                    <default-form-validation-provider
                      v-else
                      label="Comprovante de residência"
                      v-slot="defaultState"
                    >
                      <b-form-file
                        :disabled="pendenteValid"
                        v-model="novoUsuario.comp_residencia"
                        placeholder="Nenhum arquivo selecionado"
                        accept="application/pdf"
                        :state="defaultState.state"
                      />
                    </default-form-validation-provider>
                  </b-col>
                </b-row>
              </b-container>
            </b-card-body>
          </b-overlay>
        </b-card>
      </b-form>
    </validation-observer>
  </div>
</template>

<script lang="ts">
import { store } from "@/store";
import { UtilsTS } from "@/utilsts";
import { ValidationObserver } from "vee-validate";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import { mixins } from "vue-class-component";
import { SelectValue } from "@/types/select-value";
import { Component, Ref, Vue, Watch } from "vue-property-decorator";
import novoUsuarioService from "@/services/administracao/novoUsuarioService";
import municipioService from "@/services/administracao/municipioService";
import { NovoUsuario } from "@/types/administracao/usuarios/novo-usuario";
import HeaderSagres from "@/components/shared/HeaderSagres.vue";
import HeaderNovoUsuario from "@/components/novo-usuario/Header.vue";
import { Paginacao } from "@/types/paginacao";
const CompProps = Vue.extend({
  name: "Cadastro",
  components: {
    DefaultFormValidationProvider,
    ValidationObserver,
    HeaderNovoUsuario,
    HeaderSagres,
  },
});

@Component
export default class Cadastro extends mixins(UtilsTS, CompProps) {
  @Ref("validationobserver") validationobserver: InstanceType<
    typeof ValidationObserver
  >;
  confirmaSenha = "";
  comunicaTelefoneOptions = [
    { text: "Sim", value: true },
    { text: "Não", value: false },
  ];

  cpfDigits = "";
  cepDigits = "";
  telefoneDigits = "";

  overlayCard = false;
  novoUsuario = new NovoUsuario();
  loadingMunicipios = false;
  loadingUFs = false;
  ufEscolhido = 29; //29 - Sergipe
  listaMunicipios: SelectValue[] = [];
  listaUFs: SelectValue[] = [];

  pendenteValid = false;
  paginaCadastro = false;

  get cpfFormatted(): string {
    const d = (this.cpfDigits || "").slice(0, 11);
    if (d.length <= 3) return d;
    if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`;
    if (d.length <= 9)
      return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
    return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
  }

  get cepFormatted(): string {
    const d = (this.cepDigits || "").slice(0, 8);
    if (d.length <= 5) return d;
    return `${d.slice(0, 5)}-${d.slice(5)}`;
  }

  get telefoneFormatted(): string {
  const d = (this.telefoneDigits || "").slice(0, 11);
  if (d.length <= 2) return d;
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) {
    return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  }
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}

  async mounted() {
    store.cpf ? await this.findByCpf() : (this.paginaCadastro = true);
    if (this.paginaCadastro == true) {
      this.novoUsuario.FL_COMUNICA_TELEFONE = true;
    }

    await this.obterUFs();
    await this.listarMunicipios();
    this.alterarTelPlaceholder();
  }

  montarTimestamp(): string {
    const agora = new Date();
    return `${agora.getDate().toString().padStart(2, "0")}${(
      agora.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}${agora.getFullYear()}_${agora
      .getHours()
      .toString()
      .padStart(2, "0")}${agora.getMinutes().toString().padStart(2, "0")}${agora
      .getSeconds()
      .toString()
      .padStart(2, "0")}`;
  }

  async realizarDownloadAnexo(idAnexo: number, nomeAnexo: string) {
    try {
      const timestamp = this.montarTimestamp();
      const data = await novoUsuarioService.obterAnexoDeNovoUsuario(idAnexo);
      const extensao = nomeAnexo.split(".").pop()?.toLocaleLowerCase();
      const type = `image/${extensao}`;
      const blob = new Blob([data], { type });
      await this.download(`${nomeAnexo}_${timestamp}.pdf`, blob);
      this.$toast.success("Download realizado com sucesso!");
    } catch (e: any) {
      this.tratarError(e);
    }
  }

  async findByCpf() {
    store.blockScreen = true;
    try {
      const usuario = await novoUsuarioService.findByCpf();
      if (usuario && usuario.ID_NOVO_USUARIO) {
        this.novoUsuario = new NovoUsuario(usuario);
        this.cpfDigits = (this.novoUsuario.CPF || "").replace(/\D+/g, "");
        this.cepDigits = (this.novoUsuario.CEP || "").replace(/\D+/g, "");
        this.telefoneDigits = (this.novoUsuario.TELEFONE || "").replace(/\D+/g, "");

        if (this.novoUsuario.SITUACAO === "pendente validacao")
          this.pendenteValid = true;
        this.ufEscolhido = this.novoUsuario.CRP_MUNICIPIO?.ID_UF ?? 29;
      }
      if (!usuario) this.paginaCadastro = true;
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      store.blockScreen = false;
    }
  }

  async obterUFs() {
    try {
      this.loadingUFs = true;
      const ufs = await municipioService.getUFs();
      this.listaUFs = ufs.map((u) => ({
        value: u.ID_UF,
        text: u.NM_SIGLA + " - " + u.NM_NOME,
      }));
    } catch (e: any) {
      this.listaUFs = [];
      this.tratarError(e);
    } finally {
      this.loadingUFs = false;
    }
  }

  async listarMunicipios() {
    try {
      if (this.ufEscolhido === 0) {
        this.listaMunicipios = [];
        return;
      }
      this.loadingMunicipios = true;
      const muns = await municipioService.getMunicipios(this.ufEscolhido);
      this.listaMunicipios = muns.map((u) => ({
        value: u.ID_MUNICIPIO,
        text: u.NM_NOME,
      }));
    } catch (e: any) {
      this.listaMunicipios = [];
      this.tratarError(e);
    } finally {
      this.loadingMunicipios = false;
    }
  }

  alterarTelPlaceholder() {
    const input: any = document.querySelector(".vti__input");
    if (input) input.placeholder = "Digite o número de telefone aqui.";
  }

  onCpfInput(value: string): void {
    this.cpfDigits = (value || "").replace(/\D+/g, "").slice(0, 11);
  }

  onCepInput(value: string): void {
    this.cepDigits = (value || "").replace(/\D+/g, "").slice(0, 8);
  }

  onTelefoneInput(value: string): void {
  this.telefoneDigits = (value || "").replace(/\D+/g, "").slice(0, 11);
}

  onCpfKeydown(e: KeyboardEvent): void {
    const allowed = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Home", "End", "Tab"];
    if (e.ctrlKey || e.metaKey) return;
    if (allowed.includes(e.key)) return;
    if (!/^\d$/.test(e.key)) e.preventDefault();
  }

  onCepKeydown(e: KeyboardEvent): void {
    const allowed = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Home", "End", "Tab"];
    if (e.ctrlKey || e.metaKey) return;
    if (allowed.includes(e.key)) return;
    if (!/^\d$/.test(e.key)) e.preventDefault();
  }

  onTelefoneKeydown(e: KeyboardEvent): void {
  const allowed = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Home", "End", "Tab"];
  if (e.ctrlKey || e.metaKey) return;
  if (allowed.includes(e.key)) return;
  if (!/^\d$/.test(e.key)) e.preventDefault();
}

  async salvarNovoUsuario() {
    if (this.pendenteValid)
      return this.$toast.error(
        "Usuário pendente de validação, não é possível salvar."
      );
    store.blockScreen = true;
    try {
      const isValid = await this.validationobserver.validate();

      if (this.paginaCadastro && this.novoUsuario.SENHA !== this.confirmaSenha)
        this.$toast.error(
          "Os campos de Senha e Confirmação de senha possuem valores diferentes"
        );
      else {
        this.novoUsuario.CPF = this.cpfDigits.padStart(11, "0");
        this.novoUsuario.CEP = this.cepDigits.padStart(8, "0");
        this.novoUsuario.TELEFONE = this.telefoneDigits;
        const retorno =
          this.novoUsuario && this.novoUsuario.ID_NOVO_USUARIO
            ? await novoUsuarioService.salvarEdicaoNovoUsuario(this.novoUsuario)
            : await novoUsuarioService.criarNovoUsuario(this.novoUsuario);
        this.novoUsuario = retorno;
        this.$toast.success(`Os dados do novo usuário foram salvos!`);
        this.$router.push("/");
      }
    } catch (e: any) {
      this.tratarError(e, true);
    } finally {
      store.blockScreen = false;
    }
  }

  removerArquivo(tipo: string) {
    switch (tipo) {
      case "cpf":
        this.novoUsuario.doc_foto = undefined;
        break;
      case "cpf_verso":
        this.novoUsuario.doc_foto_verso = undefined;
        break;
      default:
        this.novoUsuario.comp_residencia = undefined;
        break;
    }
  }
}
</script>

<style scoped>
.telaCadastro {
  font-family: "Montserrat", sans-serif;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
